import type { TextKey } from "../../i18n/es.ts";
import {
  AquiferIcon,
  LayersIcon,
  SeriesIcon,
  SubBasinsIcon,
  WaterIcon,
  ZonesIcon,
} from "./panelIcons.tsx";

export type PanelKind = "subBasins" | "zones" | "outlets" | "aquifers" | "series" | "layers" | null;

/** The same 6 entries, with icon, for the pencil menu (TopBar.tsx) and the tab bar in EditBar.tsx — a single source so they don't drift apart. */
export const PANELS: {
  id: Exclude<PanelKind, null>;
  label: TextKey;
  Icon: () => JSX.Element;
}[] = [
  { id: "subBasins", label: "panels.subBasins", Icon: SubBasinsIcon },
  { id: "zones", label: "panels.zones", Icon: ZonesIcon },
  { id: "outlets", label: "infoPopover.outletPoints", Icon: WaterIcon },
  { id: "aquifers", label: "infoPopover.aquifers", Icon: AquiferIcon },
  { id: "series", label: "panels.inputSeries", Icon: SeriesIcon },
  { id: "layers", label: "panels.layers", Icon: LayersIcon },
];
